import * as React from "react";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { List, ListItemText, Collapse, ListItemButton } from "@mui/material";
import { useSidebarState } from "react-admin";
import { useTheme } from "@mui/material/styles";

export const SubMenu = (props) => {
  const {
    isDropdownOpen = false,
    primaryText,
    leftIcon,
    children,
    count,
  } = props;
  const [open] = useSidebarState();
  const [isOpen, setIsOpen] = useState(isDropdownOpen);
  const theme = useTheme();

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <React.Fragment>
      <ListItemButton
        dense
        onClick={handleToggle}
        sx={{
          paddingLeft: "1rem",
          color: theme.palette.text.secondary,
          flex: 1,
        }}
      >
        {leftIcon}
        <ListItemText
          inset
          disableTypography
          primary={primaryText}
          sx={{
            paddingLeft: 2,
            fontSize: "1rem",
          }}
        />
        {count}
        {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItemButton>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          sx={
            open
              ? {
                  paddingLeft: "25px",
                  transition:
                    "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
                }
              : {
                  paddingLeft: 0,
                  transition:
                    "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
                }
          }
        >
          {children}
        </List>
      </Collapse>
    </React.Fragment>
  );
};

export default SubMenu;
